/*
 * 選定支援事例 詳細 取得
 */
import { apiGetOne } from '@/actions/ApiBaseActions';
export const API_GET_ONE_CASE = 'API_GET_ONE_CASE';
/**
 * 選定支援事例詳細 取得
 */
export const apiGetOneCase = ({ path: { id } }, meta) => apiGetOne(API_GET_ONE_CASE, `/support_example/${id}/detail`, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
